module.exports = __webpack_public_path__ + "static/media/dog7.626c3677.jpeg";